import React from "react";
import { Outlet, Navigate } from "react-router-dom";

const PrivateComponent = () => {
 const auth = localStorage.getItem("isAuth");
return auth === "true" ? <Outlet /> : <Navigate to="/pristinepvSignIn" />;

};

export default PrivateComponent;
